import cookiePolicyHtml from "../assets/Legal/CookiePolicy.md?html";
import { createRoute } from "../lib/createRoute";
import LegalMarkdown from "../pages/LegalMarkdown";

export const Route = createRoute(
  "/cookie-policy",
  () => <LegalMarkdown htmlText={cookiePolicyHtml} />,
  "Cookie Policy | Flowstep",
  "This Cookie Policy explains how Flowstep uses cookies and similar technologies to collect information when you visit our website.",
);
